import authCodeMap from "@/dataBase/authCodeMap";
const budgetActivityEditRoutes = [{
  path: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_edit,
  name: "budgetActivityDoctorMedicalActivityEdit",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/editPage.vue"),
  meta: {
    title: "活动管理_活动编辑",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_edit,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_doctorActivity_edit,
  name: "budgetActivityDoctorActivityEdit",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/popularEditPage.vue"),
  meta: {
    title: "活动管理_活动编辑",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_doctorActivity_edit,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_surveyActivity_edit,
  name: "budgetActivitySurveyActivityEdit",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/surveyActivityManage/editPage.vue"),
  meta: {
    title: "活动管理_活动编辑",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_surveyActivity_edit,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_streamActivity_edit,
  name: "budgetActivityStreamActivityEdit",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/streamActivityManage/editPage.vue"),
  meta: {
    title: "活动管理_活动编辑",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_streamActivity_edit,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_medicalStreamActivity_edit,
  name: "budgetActivityMedicalStreamActivityEdit",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/medicalStreamActivityManage/editPage.vue"),
  meta: {
    title: "医学讲堂活动_活动编辑",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_medicalStreamActivity_edit,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_consultActivity_edit,
  name: "budgetActivityConsultActivityEdit",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/consultActivityManage/editPage.vue"),
  meta: {
    title: "活动管理_活动编辑",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_consultActivity_edit,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_healthInterpretActivity_edit,
  name: "budgetActivityHealthInterpretActivityEdit",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/healthInterpretActivityManage/editPage.vue"),
  meta: {
    title: "活动管理_活动编辑",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_healthInterpretActivity_edit,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_caseActivity_edit,
  name: "budgetActivityCaseActivityEdit",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/caseActivityManage/editPage.vue"),
  meta: {
    title: "活动管理_活动编辑",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_caseActivity_edit,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_reviewsActivity_edit,
  name: "budgetActivityReviewsActivityEdit",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/reviewsActivityManage/editPage.vue"),
  meta: {
    title: "活动管理_活动编辑",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_reviewsActivity_edit,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_expertAnswerActivity_edit,
  name: "budgetActivityExpertAnswerActivityEdit",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/expertAnswerActivityManage/editPage.vue"),
  meta: {
    title: "活动管理_活动编辑",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_expertAnswerActivity_edit,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_edit,
  name: "budgetActivityDoctorQuestionActivityEdit",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/doctorQuestionActivityManage/editPage.vue"),
  meta: {
    title: "活动管理_活动编辑",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_edit,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_liveActivity_edit,
  name: "budgetActivityLiveActivityEdit",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/liveActivityManage/editPage.vue"),
  meta: {
    title: "活动管理_活动编辑",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_liveActivity_edit,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_medicalMeetActivity_edit,
  name: "budgetActivityMedicalMeetActivityEdit",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/medicalMeetActivityManage/editPage.vue"),
  meta: {
    title: "活动管理_活动编辑",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_medicalMeetActivity_edit,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_answerActivity_edit,
  name: "budgetActivityAnswerActivityEdit",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/answerActivityManage/editPage.vue"),
  meta: {
    title: "活动管理_活动编辑",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_answerActivity_edit,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_interviewActivity_edit,
  name: "budgetActivityInterviewActivityEdit",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/interviewActivityManage/editPage.vue"),
  meta: {
    title: "活动管理_活动编辑",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_interviewActivity_edit,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_edit,
  name: "budgetActivityAskAndAnswerQuicklyActivityEdit",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/askAndAnswerQuicklyActivityManage/editPage.vue"),
  meta: {
    title: "活动管理_活动编辑",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_edit,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}];
// 预算活动复用原活动详情页路由，统一沉淀到独立模块入口下
const budgetActivityDetailRoutes = [{
  path: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_detail,
  name: "budgetActivityDoctorMedicalActivityDetail",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/activityDetailPage.vue"),
  meta: {
    title: "活动管理_活动列表_活动详情",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_detail,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_doctorActivity_detail,
  name: "budgetActivityDoctorActivityDetail",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/popularActivityDetailPage.vue"),
  meta: {
    title: "活动管理_活动列表_活动详情",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_doctorActivity_detail,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_surveyActivity_detail,
  name: "budgetActivitySurveyActivityDetail",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/surveyActivityManage/activityDetailPage.vue"),
  meta: {
    title: "活动管理_活动列表",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_surveyActivity_detail,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_streamActivity_detail,
  name: "budgetActivityStreamActivityDetail",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/streamActivityManage/activityDetailPage.vue"),
  meta: {
    title: "活动管理_活动列表",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_streamActivity_detail,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_medicalStreamActivity_detail,
  name: "budgetActivityMedicalStreamActivityDetail",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/medicalStreamActivityManage/activityDetailPage.vue"),
  meta: {
    title: "医学讲堂活动_活动列表",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_medicalStreamActivity_detail,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_consultActivity_detail,
  name: "budgetActivityConsultActivityDetail",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/consultActivityManage/activityDetailPage.vue"),
  meta: {
    title: "活动管理_活动列表",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_consultActivity_detail,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_healthInterpretActivity_detail,
  name: "budgetActivityHealthInterpretActivityDetail",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/healthInterpretActivityManage/activityDetailPage.vue"),
  meta: {
    title: "活动管理_活动列表",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_healthInterpretActivity_detail,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_caseActivity_detail,
  name: "budgetActivityCaseActivityDetail",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/caseActivityManage/activityDetailPage.vue"),
  meta: {
    title: "活动管理_活动列表",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_caseActivity_detail,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_reviewsActivity_detail,
  name: "budgetActivityReviewsActivityDetail",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/reviewsActivityManage/activityDetailPage.vue"),
  meta: {
    title: "活动管理_活动列表",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_reviewsActivity_detail,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_expertAnswerActivity_detail,
  name: "budgetActivityExpertAnswerActivityDetail",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/expertAnswerActivityManage/activityDetailPage.vue"),
  meta: {
    title: "活动管理_活动列表",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_expertAnswerActivity_detail,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_detail,
  name: "budgetActivityDoctorQuestionActivityDetail",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/doctorQuestionActivityManage/activityDetailPage.vue"),
  meta: {
    title: "活动管理_活动列表",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_detail,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_liveActivity_detail,
  name: "budgetActivityLiveActivityDetail",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/liveActivityManage/activityDetailPage.vue"),
  meta: {
    title: "活动管理_活动列表",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_liveActivity_detail,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_medicalMeetActivity_detail,
  name: "budgetActivityMedicalMeetActivityDetail",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/medicalMeetActivityManage/activityDetailPage.vue"),
  meta: {
    title: "活动管理_活动列表",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_medicalMeetActivity_detail,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_answerActivity_detail,
  name: "budgetActivityAnswerActivityDetail",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/answerActivityManage/activityDetailPage.vue"),
  meta: {
    title: "活动管理_活动列表",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_answerActivity_detail,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_interviewActivity_detail,
  name: "budgetActivityInterviewActivityDetail",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/interviewActivityManage/activityDetailPage.vue"),
  meta: {
    title: "活动管理_活动列表",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_interviewActivity_detail,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_detail,
  name: "budgetActivityAskAndAnswerQuicklyActivityDetail",
  component: () => import("@/modules/newCommunity/pages/newActivityManage/askAndAnswerQuicklyActivityManage/activityDetailPage.vue"),
  meta: {
    title: "快问快答_活动列表",
    hidden: true,
    needLogin: true,
    authCode: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_detail,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}, {
  path: authCodeMap.newCom_customerService_record_dialogueDetail,
  name: "budgetActivityCustomerServiceRecordDialogueDetail",
  component: () => import("@/modules/newCommunity/pages/customerService/MessageDeal/autoDetail.vue"),
  meta: {
    title: "对话详情",
    hidden: true,
    needLogin: false,
    authCode: authCodeMap.newCom_customerService_record_dialogueDetail,
    isNew: true,
    isBudgetSystemWhiteList: true
  }
}];
const routes = [{
  path: "/budgetActivity",
  name: "budgetActivity",
  // 预算活动统一走独立路由壳，后续在这里沉淀公共逻辑
  component: () => import("@/modules/budgetActivity/router.vue"),
  redirect: "/budgetActivity/activityTemplateEdit",
  meta: {
    title: "预算活动",
    hidden: false,
    icon: "tree",
    isNew: true,
    needLogin: false
  },
  children: [{
    path: "/login",
    name: "budgetActivityLogin",
    component: () => import("@/modules/budgetActivity/pages/login/index.vue"),
    meta: {
      title: "登录",
      hidden: false,
      icon: "tree",
      isNew: true,
      needLogin: false
    }
  }, {
    path: "projectSelect",
    name: "budgetActivityProjectSelect",
    component: () => import("@/modules/budgetActivity/pages/projectSelect/index.vue"),
    meta: {
      title: "健康项目选择",
      hidden: false,
      icon: "tree",
      isNew: true,
      needLogin: false,
      isBudgetSystemWhiteList: true
    }
  }, {
    path: "activityTemplateEdit",
    name: "budgetActivityActivityTemplateEdit",
    component: () => import("@/modules/budgetActivity/pages/activityTemplateEdit/index.vue"),
    meta: {
      title: "活动模板编辑",
      hidden: false,
      icon: "tree",
      isNew: true,
      needLogin: false,
      isBudgetSystemWhiteList: true
    }
  }, {
    path: "activityCommonTemplateEdit",
    name: "budgetActivityActivityCommonTemplateEdit",
    component: () => import("@/modules/budgetActivity/pages/activityCommonTemplateEdit/index.vue"),
    meta: {
      title: "通用活动模板编辑",
      hidden: false,
      icon: "tree",
      isNew: true,
      needLogin: false,
      isBudgetSystemWhiteList: true
    }
  }, {
    path: "activityCommonTemplateView",
    name: "budgetActivityActivityCommonTemplateView",
    component: () => import("@/modules/budgetActivity/pages/activityCommonTemplateEdit/view.vue"),
    meta: {
      title: "通用活动模板查看",
      hidden: false,
      icon: "tree",
      isNew: true,
      needLogin: false,
      isBudgetSystemWhiteList: true
    }
  }, {
    path: "questionnaireFill",
    name: "budgetActivityQuestionnaireFill",
    component: () => import("@/modules/budgetActivity/pages/questionnaireFill/index.vue"),
    meta: {
      title: "项目问卷填写",
      hidden: false,
      isNew: true,
      needLogin: false,
      isBudgetSystemWhiteList: true
    }
  }, {
    path: "healthServiceProjectTemplateManage",
    name: "budgetActivityHealthServiceProjectTemplateManage",
    // 独立外部入口只复用健康项目模板组件，不影响原活动工具模板页
    component: () => import("@/modules/budgetActivity/pages/healthServiceProjectTemplateManage/index.vue"),
    meta: {
      title: "健康项目模板管理",
      hidden: true,
      isNew: true,
      needLogin: false,
      isBudgetSystemWhiteList: true
    }
  }, {
    path: "customerServiceRecord",
    name: "budgetActivityCustomerServiceRecord",
    // 独立外部入口只复用智能会话记录组件，不影响原客服消息处理页
    component: () => import("@/modules/budgetActivity/pages/customerServiceRecord/index.vue"),
    meta: {
      title: "智能会话记录",
      hidden: true,
      isNew: true,
      needLogin: false,
      isBudgetSystemWhiteList: true
    }
  }, ...budgetActivityEditRoutes, ...budgetActivityDetailRoutes]
}];
export default routes;